export const MOCK_DATA_CUSTODIA_FAQ = {
  faq: [
    {
      id: 1,
      pergunta: "Quais são os custos da custódia remunerada?",
      resposta:
        "Para alugar suas ações, a Itaú Corretora cobra uma taxa de 30% sobre a operação.\n\nNa ponta doadora (quem disponibiliza seus ativos para aluguel), a remuneração do aluguel será tributada pelo Imposto de Renda retido na fonte, conforme tabela regressiva abaixo:\n\n1) – 22,5% em aplicações com prazo de até 180 dias;\n\n2) – 20% em aplicações com prazo de 181 dias até 360 dias;\n\n3) – 17,5% em aplicações com prazo de 361 dias até 720 dias;\n\n4) – 15% em aplicações com prazo acima de 720 dias.",
    },
    {
      id: 2,
      pergunta:
        "Vou continuar recebendo os dividendos pagos pelos emissores dos ativos?",
      resposta:
        "Sim. Mesmo alugando suas ações, você continuará recebendo os proventos eventualmente pagos, como dividendos e juros sobre capital próprio.",
    },
    {
      id: 3,
      pergunta: "Quanto posso ganhar alugando meus ativos?",
      resposta:
        'O valor da remuneração dependerá das condições de mercado e da demanda dos investidores pelos ativos de sua carteira. Para verificar as taxas médias praticadas por ativo, consulte as informações <a href="\r\nhttps://www.b3.com.br/pt_br/produtos-e-servicos/tarifas/tarifas-de-emprestimo-de-ativos/">disponíveis\r\nna B3</a>.\n\nA remuneração será calculada da seguinte forma (sem considerar custos e taxas):\n\nRemuneração do doador = (Q * C) * { [ ( 1 + Tx ) ^ (n / 252) ] - 1 }\n\n onde: \n\nQ = quantidade de Ativos emprestados\nC = cotação do ativo utilizada na operação\nTx = taxa anual do contrato\nn = número de dias úteis em que o empréstimo esteve vigente.\n\nSeus ativos serão doados ao preço de mercado que considera como referência a taxa média dos contratos doados no pregão anterior, divulgado pela B3.',
    },
    {
      id: 4,
      pergunta: "O que acontece se eu quiser vender meus ativos?",
      resposta:
        "Você pode vender seus ativos a qualquer momento, mas somente via Home Broker.",
    },
    {
      id: 5,
      pergunta: "Mesmo alugados, meus ativos continuam servindo de garantia?",
      resposta:
        "Sim. Seus ativos custodiados aqui na Itaú Corretora podem servir de garantia para outras modalidades de investimento mesmo quando estiverem alugados, conforme as regras da B3.",
    },
    {
      id: 6,
      pergunta: "Qual a segurança desse serviço?",
      resposta:
        "É importante lembrar que a Itaú Corretora tem a responsabilidade de fazer a mediação entre doador, tomador e B3 e que, ao serem criados os contratos, são estabelecidas garantias para caso de inadimplência do tomador.",
    },
    {
      id: 7,
      pergunta: "Quais ativos posso alugar?",
      resposta:
        'Você pode alugar ações (companhias abertas e listadas na B3), units (ativos compostos por mais de um tipo ou classe de valores mobiliários), ETFs (cotas de fundos de índices), BDRs Patrocinados (Brazilian Depositary Receipts) e Fundos Imobiliários selecionados (confira a lista completa <a href="https://www.b3.com.br/pt_br/produtos-e-servicos/emprestimo-de-ativos/informacoes-8AE490C964B9A9BC0164CCE5F2C9746B.htm">aqui</a>).',
    },
    {
      id: 8,
      pergunta: "Como posso cancelar o serviço?",
      resposta:
        'Acesse <a href="https://www.itaucorretora.com.br/CustodiaRemunerada/Cancelar">aqui</a> caso queira cancelar o serviço. Mesmo que seus ativos estejam alugados, eles serão devolvidos, observados os prazos da B3 e do serviço.',
    },
    {
      id: 9,
      pergunta: "Qual o custo para contatar o serviço?",
      resposta:
        "Não há custos para contratar o serviço e disponibilizar sua carteira de ativos. No entanto, fique atento à tributação (disponível acima nesta mesma página).",
    },
  ],
};
